import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchPackages } from '../api/apiService';
import PackageCard from '../components/PackageCard';

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [filters, setFilters] = useState({
    flight: '',
    duration: [],
    price: []
  });

  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortType, setSortType] = useState('');

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // URL PARAMS
  const queryCountry = queryParams.get('country');
  const queryMonth = queryParams.get('month');

  // STATES
  const [selectedCountry, setSelectedCountry] = useState(queryCountry || '');
  const [selectedMonth, setSelectedMonth] = useState(queryMonth || '');

  const withFlightCount = packages.filter(
    pkg => pkg.with_flight === true
  ).length;

  const withoutFlightCount = packages.filter(
    pkg => pkg.with_flight === false
  ).length;

  const monthNameToNumber = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  };

  // FETCH PACKAGES
  useEffect(() => {
    fetchPackages()
      .then(data => {
        setPackages(data);
        setFilteredPackages(data);
      })
      .catch(err => console.error('Package fetch error:', err));
  }, []);

  // FETCH COUNTRIES
  useEffect(() => {
    fetch('https://online.funforay.com/admin/api/cities/')
      .then(res => res.json())
      .then(data => {
        const countries = data.map(item => item.country);
        setCountryOptions([...new Set(countries)]);
      })
      .catch(err => {
        console.error('Country fetch error:', err);
        setCountryOptions([]);
      });
  }, []);

  // AUTO SEARCH FROM URL
  useEffect(() => {
    if ((queryCountry || queryMonth) && packages.length > 0) {
      handleSubmit({ preventDefault: () => {} });
    }
  }, [packages]);

  // AUTO FILTER WHEN SELECT CHANGES
  useEffect(() => {
    if ((selectedCountry || selectedMonth) && packages.length > 0) {
      handleSubmit({ preventDefault: () => {} });
    }
  }, [selectedCountry, selectedMonth, packages]);

  // SORTING
 // SORTING WITH DEBUGGING
  const sortedPackages = React.useMemo(() => {
    if (!sortType) return filteredPackages;

    return [...filteredPackages].sort((a, b) => {
      let aVal = 0;
      let bVal = 0;

      if (sortType === 'rating') {
        // Fallback to common alternative keys if customer_rating is undefined
        aVal = parseFloat(a.customer_rating || a.rating || a.avg_rating || 0);
        bVal = parseFloat(b.customer_rating || b.rating || b.avg_rating || 0);
      } else if (sortType === 'price') {
        const getPrice = (pkg) => {
          const hotel = pkg.hotel_ratings?.find(h => h.rating === '3') || pkg.hotel_ratings?.[0];
          const room = hotel?.room_types?.find(r => r.room_type === 'Double' || r.room_type === 'double');
          const priceStr = room?.adults || room?.price || '0';
          return parseInt(priceStr.toString().replace(/[^0-9]/g, '') || '0', 10);
        };

        aVal = getPrice(a);
        bVal = getPrice(b);
      } else if (sortType === 'duration') {
        aVal = parseInt(a.duration || '0', 10);
        bVal = parseInt(b.duration || '0', 10);
      }

      // Quick console log to verify what values are being compared in your browser console
      console.log(`Sorting ${sortType}:`, { aVal, bVal, sortOrder });

      if (sortOrder === 'desc') {
        return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
      } else {
        return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
      }
    });
  }, [filteredPackages, sortType, sortOrder]);

  const handleSortClick = (type) => {
    if (sortType === type) {
      setSortOrder(prev =>
        prev === 'asc' ? 'desc' : 'asc'
      );
    } else {
      setSortType(type);
      setSortOrder('desc');
    }
  };

  // MAIN SEARCH
  const handleSubmit = (e) => {
  if (e) e.preventDefault();

  setLoading(true);

  const filtered = packages.filter((pkg) => {

    // COUNTRY MATCH
    let countries = [];

    try {
      countries = JSON.parse(pkg.country || '[]');
    } catch (err) {
      console.error('Country parse error:', err);
    }

    const countryMatch = selectedCountry
      ? countries.some(
          c =>
            c.trim().toLowerCase() ===
            selectedCountry.trim().toLowerCase()
        )
      : true;

    // MONTH MATCH
    let monthMatch = true;

    if (selectedMonth) {
      const monthIndex =
        monthNameToNumber[selectedMonth];

      const fromDate = new Date(pkg.available_from);
      const toDate = new Date(pkg.available_to);

      const testDate = new Date(
        fromDate.getFullYear(),
        monthIndex,
        15
      );

      monthMatch =
        testDate >= fromDate &&
        testDate <= toDate;
    }

    return countryMatch && monthMatch;
  });

  setFilteredPackages(filtered);

  setTimeout(() => {
    setLoading(false);
  }, 500);
};

  // FLIGHT FILTER
  const handleFlightFilter = (type) => {
    const updated = {
      ...filters,
      flight: type
    };

    setFilters(updated);
    filterPackages(updated);
  };

  // CHECKBOX FILTER
  const handleCheckboxChange = (category, value) => {
    const updated = { ...filters };

    if (category === 'flight') {
      updated.flight =
        updated.flight === value ? '' : value;
    } else {
      if (updated[category].includes(value)) {
        updated[category] = updated[category].filter(
          v => v !== value
        );
      } else {
        updated[category].push(value);
      }
    }

    setFilters(updated);
    filterPackages(updated);
  };

  // FILTER PACKAGES
  const filterPackages = (filter) => {
    let filtered = [...packages];

    // COUNTRY FILTER
   if (selectedCountry) {
  filtered = filtered.filter(pkg => {

    let countries = [];

    try {
      countries = JSON.parse(pkg.country || '[]');
    } catch (err) {
      console.error('Country parse error:', err);
    }

    return countries.some(
      c =>
        c.trim().toLowerCase() ===
        selectedCountry.trim().toLowerCase()
    );
  });
}

    // MONTH FILTER
    if (selectedMonth) {
      filtered = filtered.filter(pkg => {
        const monthIndex =
          monthNameToNumber[selectedMonth];

        const fromDate = new Date(pkg.available_from);
        const toDate = new Date(pkg.available_to);

        const testDate = new Date(
          fromDate.getFullYear(),
          monthIndex,
          15
        );

        return (
          testDate >= fromDate &&
          testDate <= toDate
        );
      });
    }

    // FLIGHT FILTER
    if (filter.flight) {
      filtered = filtered.filter(pkg =>
        (filter.flight === 'with' &&
          pkg.with_flight === true) ||
        (filter.flight === 'without' &&
          pkg.with_flight === false)
      );
    }

    // DURATION FILTER
    if (filter.duration.length > 0) {
      filtered = filtered.filter(pkg => {
        let dur = parseInt(
          pkg.duration?.toString().split(' ')[0] || '0',
          10
        );

        return filter.duration.some(range => {
          if (range === 'below_4')
            return dur >= 1 && dur <= 3;

          if (range === '4_7')
            return dur >= 4 && dur <= 7;

          if (range === '7_10')
            return dur >= 8 && dur <= 10;

          if (range === '10_15')
            return dur >= 11 && dur <= 15;

          if (range === 'above_15')
            return dur > 15;

          return false;
        });
      });
    }

    // PRICE FILTER
    if (filter.price.length > 0) {
      filtered = filtered.filter(pkg => {
        let doublePrice = 0;

        try {
          const hotelRatings =
            pkg.hotel_ratings || [];

          const targetHotel =
            hotelRatings.find(h => h.rating === '3') ||
            hotelRatings[0];

          const doubleRoom =
            targetHotel?.room_types?.find(
              rt => rt.room_type === 'Double'
            );

          doublePrice = parseInt(
            doubleRoom?.adults?.replace(/[^0-9]/g, '') || '0',
            10
          );
        } catch (err) {
          console.error('Price parse error:', err);
        }

        return filter.price.some(range => {

          if (range === '300000+') {
            return doublePrice > 300000;
          }

          const [min, max] = range
            .split('-')
            .map(Number);

          return (
            doublePrice >= min &&
            doublePrice <= max
          );
        });
      });
    }

    setFilteredPackages(filtered);
  };

  // RESET FILTERS
  const resetFilters = () => {
    setSelectedCountry('');
    setSelectedMonth('');

    setFilters({
      flight: '',
      duration: [],
      price: []
    });

    setFilteredPackages(packages);

    window.history.replaceState(
      {},
      document.title,
      window.location.pathname
    );
  };

  // CHECK ACTIVE FILTERS
  const isFilterActive =
    filters.flight !== '' ||
    filters.duration.length > 0 ||
    filters.price.length > 0;

  return (
    <div className="allPack">

      {/* SEARCH FORM */}
      <div className="modify_form">

        <form onSubmit={handleSubmit} onReset={resetFilters}>

          {/* COUNTRY */}
          <div className="form-group-floating">
            <select
              required
              className="form-control custom-select"
              value={selectedCountry}
              onChange={(e) =>
                setSelectedCountry(e.target.value)
              }
            >
              <option value="" disabled hidden>
                Select Country
              </option>

              {countryOptions.length > 0 ? (
                countryOptions.map((country, idx) => (
                  <option key={idx} value={country}>
                    {country}
                  </option>
                ))
              ) : (
                <option disabled>
                  Loading countries...
                </option>
              )}
            </select>

            <label>Country</label>
          </div>

          {/* MONTH */}
          <div className="form-group-floating">
            <select
              className="form-control custom-select"
              value={selectedMonth}
              onChange={(e) =>
                setSelectedMonth(e.target.value)
              }
            >
              <option value="" disabled hidden>
                Select Month
              </option>

              {Object.keys(monthNameToNumber).map(
                (month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                )
              )}
            </select>

            <label>Month</label>
          </div>

          {/* BUTTONS */}
          <div className="form-buttons">
            <button
              type="submit"
              style={styles.submitBtn}
            >
              Modify Search
            </button>

            <button
              type="reset"
              style={styles.submitBtn}
            >
              Reset
            </button>
          </div>

        </form>
      </div>

      {/* MAIN */}
      <div className='cards_package'>

        {/* SIDEBAR */}
        <div className='filter_sidebar'>

          <h4 className='fil_title'>
            <img src='../images/filter.png' alt="" />
            Filters
          </h4>

          {/* DURATION */}
          <div className='filter_design'>
            <p>Duration</p>

            {[
              ['below_4', 'Below 4 Nights'],
              ['4_7', '4–7 Nights'],
              ['7_10', '7–10 Nights'],
              ['10_15', '10–15 Nights'],
              ['above_15', 'Above 15 Nights']
            ].map(([value, label]) => (
              <div key={value}>
                <label>
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleCheckboxChange(
                        'duration',
                        value
                      )
                    }
                    checked={filters.duration.includes(value)}
                  />

                  {label}
                </label>
              </div>
            ))}
          </div>

          {/* FLIGHT */}
          <div className='filter_design'>
            <p>Flights</p>

            <div
              style={{
                marginTop: '10px',
                display: 'flex',
                gap: '10px',
                flexWrap: 'wrap'
              }}
            >

              <button
                type="button"
                style={{
                  ...styles.flightBtn,
                  backgroundColor:
                    filters.flight === 'with'
                      ? '#E2068C'
                      : '#fff',
                  color:
                    filters.flight === 'with'
                      ? '#fff'
                      : '#E2068C',
                  border: '1px solid #E2068C'
                }}
                onClick={() =>
                  handleFlightFilter('with')
                }
              >
                With Flight ({withFlightCount})
              </button>

              <button
                type="button"
                style={{
                  ...styles.flightBtn,
                  backgroundColor:
                    filters.flight === 'without'
                      ? '#E2068C'
                      : '#fff',
                  color:
                    filters.flight === 'without'
                      ? '#fff'
                      : '#E2068C',
                  border: '1px solid #E2068C'
                }}
                onClick={() =>
                  handleFlightFilter('without')
                }
              >
                Without Flight ({withoutFlightCount})
              </button>

            </div>
          </div>

          {/* PRICE */}
          <div className='filter_design'>
            <p>Price Range</p>

            {[
              ['0-50000', 'Below ₹50,000'],
              ['50000-100000', '₹50,000 – ₹1,00,000'],
              ['100000-200000', '₹1,00,000 – ₹2,00,000'],
              ['200000-300000', '₹2,00,000 – ₹3,00,000'],
              ['300000+', 'Above ₹3,00,000']
            ].map(([value, label]) => (
              <div key={value}>
                <label>
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleCheckboxChange(
                        'price',
                        value
                      )
                    }
                    checked={filters.price.includes(value)}
                  />

                  {label}
                </label>
              </div>
            ))}
          </div>

          {/* RESET */}
          <button
            onClick={resetFilters}
            disabled={!isFilterActive}
            style={{
              marginTop: '20px',
              padding: '8px 16px',
              backgroundColor: '#E2068C',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: isFilterActive
                ? 'pointer'
                : 'not-allowed',
              opacity: isFilterActive ? 1 : 0.5,
              fontSize: '14px',
              margin: '20px',
            }}
          >
            Reset Filters
          </button>

        </div>

        {/* PACKAGES */}
        {loading ? (
          <p className="loading">Loading...</p>
        ) : filteredPackages.length === 0 ? (
          <p>No matching packages found.</p>
        ) : (

          <div
            style={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '20px'
            }}
          >

            {/* SORT */}
            <div className='sortby'>

              <div>
                <p>Sort By:</p>
              </div>

              <div className='sorts_item'>

                {['rating', 'price', 'duration'].map(
                  (type) => (
                    <p
                      key={type}
                      onClick={() =>
                        handleSortClick(type)
                      }
                      style={{
                        fontWeight:
                          sortType === type
                            ? 'bold'
                            : 'normal',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        marginRight: '12px',
                      }}
                    >
                      {/* {type === 'rating' &&
                        'Customer Rating'} */}

                      {type === 'price' &&
                        'Price'}

                      {type === 'duration' &&
                        'Duration'}

                      {sortType === type && (
                        <span
                          style={{ color: '#E2068C' }}
                        >
                          {sortOrder === 'asc'
                            ? '↑'
                            : '↓'}
                        </span>
                      )}
                    </p>
                  )
                )}

              </div>
            </div>

            {/* CARDS */}
            {sortedPackages.map((pkg, index) => (
              <PackageCard
                key={index}
                pkg={pkg}
              />
            ))}

          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  submitBtn: {
    padding: '10px 20px',
    backgroundColor: '#EA028F',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '19px',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    fontWeight: '800',
  },

  flightBtn: {
    padding: '8px 14px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
  },
};

export default Packages;